<template>
	<b-modal
		id="ConfirmationModal"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		no-close-on-esc
		:visible="showModal"
	>
		<div class="d-flex w-100">
			<div class="w-100">
				<div class="d-flex align-items-center w-100">
					<div>
						<img :src="getSvg" />
					</div>
					<div class="w88">
						<div class="pff-modal-heading ml-3 d-flex justify-content-between">
							<div class="modal-hd-txt">{{ header }}</div>
							<div class="pointer ml-3">
								<img
									@click="$bvModal.hide('ConfirmationModal'), $emit('close')"
									class="rotate-on-hover"
									src="../../assets/projects-icons/x-close.svg"
									alt=""
								/>
							</div>
						</div>
						<div class="mt-1 ml-3 text-break caution-txt">
							<span v-html="confirmMessage"></span>
						</div>
					</div>
				</div>

				<div class="position-relative mt-2">
					<div v-if="caution" class="normaltext">
						<span class="asterik">*</span
						><span>Please note this action cannot be undone</span>
					</div>
				</div>
			</div>
		</div>
		<div class="d-flex align-items-center justify-content-end mt-3">
			<div class="d-flex align-items-center justify-content-between">
				<div class="cancel-btn">
					<b-button
						class="mr-2"
						@click="$bvModal.hide('ConfirmationModal'), $emit('close')"
					>
						Cancel
					</b-button>
				</div>
				<div class="new-addbtn-modal">
					<b-button :disabled="loader" @click="$emit('save')">
						<span v-if="loader">
							<b-spinner
								small
								type="border"
								class="mr-2"
								label="Loading..."
							></b-spinner>
						</span>
						<span v-else>
							{{ button }}
						</span>
					</b-button>
				</div>
			</div>
		</div>
	</b-modal>
</template>

<script>
export default {
	props: {
		caution: {
			type: Boolean,
			default: false,
		},
		header: {
			type: String,
			default: "Caution",
		},
		button: String,
		confirmMessage: String,
		svgPath: {
			type: String,
		},
		showModal: {
			type: Boolean,
		},
		loader: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {};
	},
	computed: {
		getSvg() {
			console.log(`@/assets/${this.svgPath}`);
			return require(`@/assets/${this.svgPath}`);
		},
	},
};
</script>
<style>
@media (min-width: 576px) {
	#ConfirmationModal .modal-dialog {
		max-width: 544px;
		margin: 1.75rem auto;
	}
}
</style>
<style scoped>
.w88 {
	width: 88%;
}
.cancel-btn .btn-secondary {
	background-color: #fff;
	border-color: #72738e;
	border-radius: 40px;
	padding: 4px 13px 3px 13px;
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 13px;
	color: #72738e;
	width: 85px;
	height: 31px;
}
.new-addbtn-modal .btn-secondary {
	background-color: var(--navy-blue);
	border-radius: 40px;
	border: 1px solid var(--navy-blue);
	font-family: var(--Montserrat);
	font-size: 13px;
	font-weight: var(--weight-M);
	color: #ffffff;
	padding: 4px 13px 3px 13px;
	width: 90px;
	height: 31px;
}
.caution-txt {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 13px;
	color: #344054;
}
.modal-hd-txt {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 18px;
	color: #000000;
}
</style>
